var _AnalyticsManager_config, _AnalyticsManager_useMixpanel, _AnalyticsManager_useHubspot;
import { __awaiter, __classPrivateFieldGet, __classPrivateFieldSet, __decorate } from "tslib";
import { singleton } from 'tsyringe';
import * as mixpanel from 'mixpanel-browser';
let AnalyticsManager = class AnalyticsManager {
    constructor() {
        _AnalyticsManager_config.set(this, void 0);
        _AnalyticsManager_useMixpanel.set(this, void 0);
        _AnalyticsManager_useHubspot.set(this, void 0);
    }
    init(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.registerMixpanel(config);
            this.registerHubspot(config);
        });
    }
    registerMixpanel(config) {
        var _a;
        try {
            if ((_a = config.analytics) === null || _a === void 0 ? void 0 : _a.mixpanelToken) {
                mixpanel.init(config.analytics.mixpanelToken);
                __classPrivateFieldSet(this, _AnalyticsManager_useMixpanel, true, "f");
            }
        }
        catch (error) {
            console.warn('Unable to start mixpanel');
        }
    }
    registerHubspot(config) {
        var _a;
        try {
            this.registerMixpanel(config);
            if ((_a = config.analytics) === null || _a === void 0 ? void 0 : _a.hubspotToken) {
                // TODO: Hubspot init
                __classPrivateFieldSet(this, _AnalyticsManager_useHubspot, true, "f");
            }
        }
        catch (error) {
            console.warn('Unable to start hubspot');
        }
    }
    identify(data) {
        try {
            if (__classPrivateFieldGet(this, _AnalyticsManager_useMixpanel, "f")) {
                mixpanel.identify(data.id);
                mixpanel.people.set({
                    $email: data.email,
                    $name: data.name,
                });
            }
            if (__classPrivateFieldGet(this, _AnalyticsManager_useHubspot, "f")) {
                // TODO: Hubspot identify
            }
        }
        catch (err) {
            console.warn('Unable to identify user');
        }
    }
    trackEvent(eventName, trackData) {
        try {
            if (__classPrivateFieldGet(this, _AnalyticsManager_useMixpanel, "f")) {
                mixpanel.track(eventName, trackData);
            }
            if (__classPrivateFieldGet(this, _AnalyticsManager_useHubspot, "f")) {
                // TODO: Hubspot track
            }
        }
        catch (err) {
            console.log(err);
        }
    }
    trackPageView() {
        const { host, pathname } = window.location;
        this.trackEvent('Page View', {
            gt_Location: `${host}${pathname}`,
        });
    }
    reset() {
        if (__classPrivateFieldGet(this, _AnalyticsManager_useMixpanel, "f")) {
            mixpanel.reset();
        }
        if (__classPrivateFieldGet(this, _AnalyticsManager_useHubspot, "f")) {
            // TODO: Hubspot identify
        }
    }
};
_AnalyticsManager_config = new WeakMap();
_AnalyticsManager_useMixpanel = new WeakMap();
_AnalyticsManager_useHubspot = new WeakMap();
AnalyticsManager = __decorate([
    singleton()
], AnalyticsManager);
export { AnalyticsManager };
